import { ContentLabelInfoSvg } from '@/Components/Icons/ContentLabelInfoSvg';
import { ContentLabelQuestionSvg } from '@/Components/Icons/ContentLabelQuestionSvg';
import { ContentLabelVerifiedSvg } from '@/Components/Icons/ContentLabelVerifiedSvg';
import {
    ContentLabel,
    GENERATED_FOOTAGE_AND_AUDIO_CONTENT_LABEL,
    GENERATED_FOOTAGE_AND_REAL_AUDIO_CONTENT_LABEL,
    REAL_FOOTAGE_AND_AUDIO_CONTENT_LABEL,
    REAL_FOOTAGE_AND_GENERATED_AUDIO_CONTENT_LABEL,
    UNKNOWN_CONTENT_LABEL,
} from '@/types/reel.type';

export function useContentLabelUiData(size: number = 24) {
    return {
        [UNKNOWN_CONTENT_LABEL]: {
            icon: <ContentLabelQuestionSvg width={size} height={size} />,
            label: 'Video may contain AI-generated content',
        },
        [REAL_FOOTAGE_AND_AUDIO_CONTENT_LABEL]: {
            icon: <ContentLabelVerifiedSvg width={size} height={size} />,
            label: 'Real video footage and audio',
        },
        [GENERATED_FOOTAGE_AND_AUDIO_CONTENT_LABEL]: {
            icon: <ContentLabelInfoSvg width={size} height={size} />,
            label: 'Video and audio is AI-generated',
        },
        [GENERATED_FOOTAGE_AND_REAL_AUDIO_CONTENT_LABEL]: {
            icon: <ContentLabelInfoSvg width={size} height={size} />,
            label: 'AI-generated video, real audio',
        },
        [REAL_FOOTAGE_AND_GENERATED_AUDIO_CONTENT_LABEL]: {
            icon: <ContentLabelInfoSvg width={size} height={size} />,
            label: 'Real video, AI-generated audio',
        },
    } as Record<ContentLabel, any>;
}
